import { render, staticRenderFns } from "./_standard.vue?vue&type=template&id=23b62375&"
import script from "./_standard.vue?vue&type=script&lang=js&"
export * from "./_standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports